export default class {
    public login: string;
    public password: string;
}


// WEBPACK FOOTER //
// ./src/viewmodels/SignIn.ts